// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".adjust-framing-blade {\n\t.footer-actions .c-button {\n\t\tmargin-left: 10px;\n\t}\n\n\t.c-modal__content {\n\t\tmargin: 0;\n\t}\n}\n", "",{"version":3,"sources":["AdjustFramingBlade.css"],"names":[],"mappings":"AAAA;CACC;EACC,iBAAiB;CAClB;;CAEA;EACC,SAAS;CACV;AACD","file":"AdjustFramingBlade.css","sourcesContent":[".adjust-framing-blade {\n\t.footer-actions .c-button {\n\t\tmargin-left: 10px;\n\t}\n\n\t.c-modal__content {\n\t\tmargin: 0;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
